import utils from 'utils'
import detailPage from './view/detail.html'

class warningModal {
    constructor($scope, httpRequest, $uibModal, logger, sweetalert, $filter, $uibModalInstance, $stateParams, items1) {
        console.log(items1)
        $scope.invoiceList = items1
        $scope.confirmId = items1.length>0?Number(items1[0].confirmId):''
        $scope.data = items1[0]

        httpRequest.get_dictByTypeArr(['red_confirm_red_reason','red_confirm_status'])
            .then((res) => {
                $scope.dictData = res.data.value
            })
        $scope.previewTheBill = (item) => {
            $uibModal
                .open({
                    template: detailPage,
                    controller: 'redInkConfirmFormDetailCtrl',
                    backdrop: 'static',
                    openedClass: 'mod-modal mod-modal-hg-redFrom',
                    resolve: {
                        items1() {
                            return {
                                item: item,
                                title: '已上传红字确认单',
                            }
                        },
                    },
                })
                .result.then(
                () => {},
                () => {}
            )
        }
        // 关闭
        $scope.chooseInv = function (item) {
            console.log(item)
            $scope.confirmId = Number(item.confirmId)
            $scope.data = item
        }
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss('cancel')
        }
        $scope.manualContact = function () {
            if (!$scope.data) return logger.logError('请选择红字确认单进行关联')
            httpRequest.post_redConfirmRelate($scope.data).then((res) => {
                logger.logSuccess('关联成功')
                $uibModalInstance.close('关联')
            })
        }
        $scope.ok = function () {
            $uibModalInstance.close($scope.data)
        }
    }
}

warningModal.$inject = ['$scope', 'httpRequest', '$uibModal', 'logger', 'sweetalert', '$filter', '$uibModalInstance', '$stateParams', 'items1']
export default warningModal



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/redInkConfirmForm/warnModal.js